import { doApi } from './apiClient';
import type { Arena, PaginatedResponse, ApiResponse } from '../types';

export const apiListArenasByPage = async (
  page: number | string = 0
): Promise<PaginatedResponse<Arena>> => {
  return doApi<PaginatedResponse<Arena>>(`api/arenas/list?page=${page}`, 'GET');
};

export const apiListArenasByInputSearch = async (
  searchName: string
): Promise<PaginatedResponse<Arena>> => {
  const body = { searchName };
  return doApi<PaginatedResponse<Arena>>('api/arenas/list', 'POST', body);
};

export const apiGetArena = async (id: number): Promise<Arena> => {
  return doApi<Arena>(`api/arenas/get/${id}`, 'GET');
};

export const apiCreateArena = async (data: FormData): Promise<ApiResponse<Arena>> => {
  return doApi<ApiResponse<Arena>>('api/arenas/create', 'POST', data, true);
};

export const apiEditArena = async (
  data: FormData,
  id: number
): Promise<ApiResponse<Arena>> => {
  return doApi<ApiResponse<Arena>>(`api/arenas/edit/${id}`, 'POST', data, true);
};

// V2 APIs
export const apiCreateArenaV2 = async (data: FormData): Promise<ApiResponse<Arena>> => {
  return doApi<ApiResponse<Arena>>('api/arenas/v2/create', 'POST', data, true);
};
